import { render, staticRenderFns } from "./wxDiscussBox.vue?vue&type=template&id=597df588&"
import script from "./wxDiscussBox.vue?vue&type=script&lang=js&"
export * from "./wxDiscussBox.vue?vue&type=script&lang=js&"
import style0 from "./wxDiscussBox.vue?vue&type=style&index=0&id=597df588&prod&lang=less&"
import style1 from "./wxDiscussBox.vue?vue&type=style&index=1&id=597df588&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports